<template>
    <div style="text-align: center;">
        <h1>(404) Page Not Found</h1>
        <br/>
        <h4>Are you looking for our app? <a href="/app"> Click here.</a></h4>
    </div>
</template>

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

<script>
export default {
    metaInfo () {
        return {
            title: "Page Not Found | Wersa",
            robots: "noindex"
        };
    },
};
</script>